// src/components/Layout.jsx
import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Box } from '@mui/material'; // Usamos Box para mejor manejo de layout flex

import ResponsiveNavBar from './ResponsiveNavBar';
import FooterSection from './FooterSection';
import CookieBanner from './CookieBanner';
import SkipLink from './SkipLink';

function Layout() {
  const { pathname } = useLocation();

  // 1. LÓGICA DE SCROLL AUTOMÁTICO
  // Cada vez que cambia la ruta (pathname), subimos el scroll a (0,0)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Lógica del padding superior
  // Consejo: 160px puede ser mucho. Si ves mucho hueco, prueba con 80px o 100px.
  const topOffset = pathname === '/' ? 0 : '100px';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      {/* SKIP LINK FOR ACCESSIBILITY */}
      <SkipLink />

      {/* HEADER GLOBAL */}
      <ResponsiveNavBar />

      {/* CONTENIDO DINÁMICO */}
      {/* flexGrow: 1 hace que este bloque ocupe todo el espacio disponible, empujando el footer abajo */}
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{
          flexGrow: 1,
          paddingTop: topOffset,
          // Añadimos una transición suave si cambias de padding, queda fino
          transition: 'padding-top 0.3s ease',
          outline: 'none' // Evita outline visible cuando se hace focus programáticamente
        }}
      >
        <Outlet />
      </Box>

      {/* FOOTER GLOBAL */}
      <FooterSection />

      {/* LEGAL */}
      <CookieBanner />

    </Box>
  );
}

export default Layout;



